//
// @descr 	Generate AJAX request based on user-specified filter criteria.
// @params	object sender - to check which element of the form triggered the AJAX call.
// @params	int isAnalyzeSlides -- determine which HTML form we're being called from
// @params	int projectId -- the project filter
// @params	object event -- event that triggered the AJAX call.
// @return 	N/A
//
const DoAnalysisMacrosAjaxRequest = _.debounce(debounceMacroSearchTextbox, 500);

function debounceMacroSearchTextbox(sender, isAnalyzeSlides, projectId, event)
{
	var allMacrosCheckBox = document.getElementById('AllMacrosCheckBox');
	var myMacrosCheckBox = document.getElementById('MyMacrosCheckBox');
	var projectMacrosCheckBox = null;
	if (isAnalyzeSlides)
	{
		projectMacrosCheckBox = document.getElementById('ProjectMacrosCheckBox');
	}
	if (sender.id == "AllMacrosCheckBox")
	{
		allMacrosCheckBox.checked = true;
		allMacrosCheckBox.disabled = true;
		myMacrosCheckBox.checked = false;
		if (projectMacrosCheckBox != null)
		{
			projectMacrosCheckBox.checked = false;
		}
	}
	else
	{
		if (!myMacrosCheckBox.checked && ((projectMacrosCheckBox == null) || !projectMacrosCheckBox.checked))
		{
			allMacrosCheckBox.checked = true;
			allMacrosCheckBox.disabled = true;
		}
		else
		{
			allMacrosCheckBox.disabled = false;
			allMacrosCheckBox.checked = false;
		}
	}
	var macroSearchTextBox = document.getElementById('MacroSearchTextBox');
	if (!isAnalyzeSlides)
	{
		AjaxRequestMatches_AnalysisMacros(macroSearchTextBox, myMacrosCheckBox.checked, false, projectId, false, event);
	}
	else
	{
		AjaxRequestMatches_AnalysisMacros(macroSearchTextBox, myMacrosCheckBox.checked, projectMacrosCheckBox.checked, projectId, true, event);
	}
}

//
// @descr Given the various filters passed in, call the DataServer and return
// results.
// @params string searchTextBox -- the text filter on the page.
// @params int searchOnMyMacros -- search by the user id logged in.
// @params int searchOnProjectMacros -- Project/macro association filter.
// @params int projectId -- Project/macro filter is the projectId.
// @params int isAnalyzeSlides -- indicates which form initiated this AJAX
// request.
// @return N/A
//
function AjaxRequestMatches_AnalysisMacros(searchTextBox, searchOnMyMacros, searchOnProjectMacros, projectId, isAnalyzeSlides, e)
{
	// Ignore some keys
	if (e != null)
	{
		if ((e.keyCode == 13) || // enter
		(e.keyCode == 9) || // tab
		(e.keyCode == 38) || // up arrow
		(e.keyCode == 40) || // down arrow
		(e.keyCode == 27))
		{
			return;
		}
	}

	var http_request = false;

	if (window.XMLHttpRequest)
	{
		http_request = new XMLHttpRequest();
	}
	else if (window.ActiveXObject)
	{
		http_request = new ActiveXObject("Microsoft.XMLHTTP");
	}
	if (!http_request)
	{
		alert('Giving up :( Cannot create an XMLHTTP instance');
		return false;
	}
	http_request.open('POST', '/AnalysisMacros_GetSearchResults.php', true);
	http_request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	http_request.onreadystatechange = function()
	{
		AjaxShowMatches_AnalysisMacros(http_request);
	};
	var queryString = 'IsAnalyzeSlides=' + isAnalyzeSlides + '&MyMacros=' + searchOnMyMacros + '&ProjectMacros=' + searchOnProjectMacros + '&ProjectId=' + projectId + '&MacroName=' + escape(searchTextBox.value);
	http_request.send(queryString);
}

//
// @descr Look at the Dataserver response and process.
// @params object http_request -- holds the return information from DataServer.
// @return N/A
//
function AjaxShowMatches_AnalysisMacros(http_request)
{
	if (http_request.readyState == 4)
	{
		if (http_request.status == 200)
		{
			var Response = eval('(' + http_request.responseText + ')');
			var Error = Response['ErrorMsg'];
			if (Error == '')
			{
				var cList = GlobalList.GetList('MacroList');
				if (typeof (cList) !== 'undefined' && cList)
				{
					cList.Refresh(true);
				}
				else
				{
					cList = GlobalList.GetList('MacroSlideAnalysisList');
					cList.Refresh(true);
				}
			}
			else
			{
				alert(Error);
			}
		}
		else
		{
			alert('There was a problem updating list of analysis macros.');
		}
	}
}

function DoAjaxRequest_NameCheck(form, macroName)
{
	var http_request = false;

	if (window.XMLHttpRequest)
	{
		http_request = new XMLHttpRequest();
	}
	else if (window.ActiveXObject)
	{
		http_request = new ActiveXObject("Microsoft.XMLHTTP");
	}
	if (!http_request)
	{
		alert('Giving up :( Cannot create an XMLHTTP instance');
		return false;
	}
	var url = '/AnalysisMacros_NameCheck.php?Macro=' + escape(macroName);
	http_request.open('POST', url, true);
	http_request.setRequestHeader('Content-Type', 'text/plain');
	http_request.onreadystatechange = function()
	{
		AjaxRequest_NameCheck(form, macroName, http_request);
	};
	http_request.send();
}

function AjaxRequest_NameCheck(form, macroName, http_request)
{
	if (http_request.readyState == 4)
	{
		if (http_request.status == 200)
		{
			var responseCode = http_request.responseText.replace(/\r\n/g, "");
			if (responseCode == "0")
			{
				form.submit();
			}
			else if (responseCode == "1")
			{
				if (confirm('A macro with the name \'' + macroName + '\' already exists. Do you want to update this macro?'))
				{
					form.submit();
				}
			}
			else if (responseCode == "2")
			{
				alert('A macro with the name \'' + macroName + '\' already exists in a DataGroup you do not have full control of. Please specify a different macro name.');
			}
			else
			{
				alert("There was an issue while checking if Macro name is unique. Please try saving again or contact your administrator if this issue persists.");
			}
		}
	}
}
